import { ChevronRight, Calendar, Users } from 'lucide-react';
import { format } from 'date-fns';
import { Card } from '../ui/Card';

export default function SeriesListItem({ series, onClick }) {
  const formatNextEvent = (nextEvent) => {
    if (!nextEvent) return null;
    const date = new Date(nextEvent.date);
    return `${format(date, 'MMM d')} @ ${nextEvent.track_name}`;
  };

  const seriesColor = series.color ? `#${series.color}` : '#64748b';

  return (
    <Card
      hover
      padding="none"
      className="group"
      onClick={() => onClick(series)}
    >
      <div className="flex items-center gap-3 px-3 py-2">
        <div
          className="w-9 h-9 rounded flex items-center justify-center flex-shrink-0 overflow-hidden"
          style={{ backgroundColor: `${seriesColor}15` }}
        >
          {series.logo_URL ? (
            <img
              src={series.logo_URL}
              alt={series.name}
              className="w-8 h-8 object-contain"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
          ) : null}
          <div
            className="w-5 h-5 rounded"
            style={{
              backgroundColor: seriesColor,
              display: series.logo_URL ? 'none' : 'block'
            }}
          />
        </div>

        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-medium text-slate-800 group-hover:text-wrg-blue-600 transition-colors truncate">
            {series.name}
          </h3>
          {series.nextEvent && (
            <p className="text-xs text-slate-500 truncate">
              Next: {formatNextEvent(series.nextEvent)}
            </p>
          )}
        </div>

        <div className="flex items-center gap-4 flex-shrink-0">
          <div className="flex items-center gap-1 text-xs text-slate-500">
            <Calendar className="w-3.5 h-3.5" />
            <span>{series.upcomingEventsCount || 0}</span>
          </div>
          <div className="flex items-center gap-1 text-xs text-slate-500">
            <Users className="w-3.5 h-3.5" />
            <span>{series.activeEntriesCount || 0}</span>
          </div>
          <ChevronRight className="w-4 h-4 text-slate-300 group-hover:text-wrg-blue-600 group-hover:translate-x-0.5 transition-all" />
        </div>
      </div>
    </Card>
  );
}
